import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { S3_BUCKET_URL } from '@/constants';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import {
  OptionItemSquare,
  OptionItemSquareList,
} from '@/pages/Onboarding/components/OptionItemSquare';
import { useOnboarding } from '@/pages/Onboarding/context';
import {
  OwnAiTitle,
  OwnAiTitleHighlight,
} from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { BODY_SHAPE_OPTIONS } from '@/pages/Onboarding/options/BodyShape/BODY_SHAPE_OPTIONS';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { nextStepTimeout } from '@/pages/Onboarding/utils/nextStepTimeout';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../types';

import { ScreenBodyShapeStyles } from './BodyShape.styles';

export const ScreenBodyShape: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'BodyShape',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const body_shape = form.watch('body_shape');

  const handleSelect = (
    option: OnbOptionType<LayoutDataType['body_shape']>,
  ) => {
    form.setValue('body_shape', option.id);
    userService.createOrUpdate({
      onboarding_data: {
        body_shape: option.title,
      },
    });
    nextStepTimeout(wizard.nextStep);
  };

  const getOptionImage = (
    option: OnbOptionType<LayoutDataType['body_shape']>,
  ) => {
    return `${S3_BUCKET_URL}/layout-own-ai/body_shape/${option.id}.png`;
  };

  return (
    <ScreenBodyShapeStyles background={'dark-solid'}>
      <OnboardingNavigation />
      <OwnAiTitle>
        Choose her <OwnAiTitleHighlight>body shape</OwnAiTitleHighlight>
      </OwnAiTitle>
      <IonContent>
        <OptionItemSquareList>
          {BODY_SHAPE_OPTIONS.map((option) => (
            <OptionItemSquare
              key={option.id}
              isSelected={body_shape === option.id}
              onClick={() => handleSelect(option)}
              bgSrc={getOptionImage(option)}
              title={option.title}
              TEST_ID={`body_shape-${option.id}`}
            />
          ))}
        </OptionItemSquareList>
      </IonContent>
    </ScreenBodyShapeStyles>
  );
};
